// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"3ae9a04a","180":"a4e9e769","721":"21cb5272","759":"dc1cdbe9","772":"81583159"}[chunkId] + ".chunk.css";
};